import React, { useEffect, useState } from 'react';
import { Checkbox, Input, Form, Select } from 'antd';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { FormLabel, FormWrap, MiniInputWrap } from 'pages/settings_page/style';
import { AntToggleButton, FormHeader, ModalFormContainer } from 'component/form_component/style';
import { useDispatch, useSelector } from 'react-redux';
import { getBrandings, updateBranding } from 'redux/slices/brandingSlice';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { AllowedDomainListWrap, AllowedDomainWrap } from 'pages/brandings/style';
import { InputPatternRule, InputPatternRuleBrandingUrl } from 'utils/input_pattern';

export default function UpdateBranding({ recordData, setModal }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const CheckboxGroup = Checkbox.Group;
  const [isToggleChecked, setIsToggleChecked] = useState(false);
  const [checkedList, setCheckedList] = useState(recordData?.allowedDomains);
  const { themeData } = useSelector((state) => state.themes);
  const { domainFromApi } = useSelector((state) => state.domainData);
  const options = domainFromApi.map((domain) => `${domain.domainName}(${domain.fqdn})`);
  const [checkAll, setCheckAll] = useState(recordData?.allowedDomains.length === options.length);

  useEffect(() => {
    if (checkedList.length > 1) {
      form.setFieldsValue({ showDomains: true });
      setIsToggleChecked(true);
    } else {
      setIsToggleChecked(false);
    }
  }, [checkedList]);

  const onFinish = async (values) => {
    try {
      values.id = recordData.id;
      values.allowedDomains = checkedList;
      const response = await dispatch(updateBranding(values));
      if (response?.payload.status === 200) {
        await SweetSweetAlert({ sweetData: response.payload.data.message, icon: 'success', buttonColor: 'green' });
        setModal(false);
        const { hostname, port } = window.location;
        const currentDomain = `${hostname}${port ? `:${port}` : ''}`;
        if (currentDomain === recordData.url) {
          window.location.reload(true);
        } else {
          dispatch(getBrandings());
        }
      } else if (response?.payload.data === 'Branding already assigned to this Url.') {
        SweetSweetAlert({ sweetData: response.payload.data, icon: 'error', buttonColor: 'red' });
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      return error;
    }
  };

  const onChange = (list) => {
    setCheckedList(list);
    setCheckAll(list.length === options.length);
    setIsToggleChecked(checkedList.length > 0);
  };

  const onCheckAllChange = (e) => {
    setCheckedList(e.target.checked ? options : []);
    setCheckAll(e.target.checked);
  };

  return (
    <ModalFormContainer className='af-modal-container af-update_branding-modal-container'>
      <FormHeader className='af-form-header af-update_branding-form-header'>Update Branding</FormHeader>
      <FormWrap className='af-form-wrap af-update_branding-form-wrap'>
        <Form
          className='af-form af-update_branding-form'
          form={form}
          onFinish={onFinish}
          initialValues={{
            name: recordData?.name,
            url: recordData?.url,
            allowedDomains: recordData?.allowedDomains,
            showDomains: recordData?.showDomains,
            themeId: recordData?.themeId,
            forgotPassword: recordData?.forgotPassword,
            rememberMe: recordData?.rememberMe,
          }}
          name='update_branding'
          size='large'
          scrollToFirstError
        >
          <FormLabel
            name='name'
            label='Name'
            className='formItemEvenLine af-form-item af-update_branding-form-item af-update_branding-form-item-name'
            rules={[
              {
                required: true,
                message: 'Please enter this field',
              },
              {
                pattern: InputPatternRule.pattern,
                message: InputPatternRule.message,
              },
            ]}
          >
            <Input
              disabled={recordData.id === 1}
              className='af-form-input af-update_branding-form-input af-update_branding-form-input_name'
            />
          </FormLabel>
          <FormLabel
            name='url'
            label='URL'
            className='formItemEvenLine af-form-item af-update_branding-form-item af-update_branding-form-item-url'
            rules={[
              {
                required: true,
                message: 'Please enter this field',
              },
              {
                pattern: InputPatternRuleBrandingUrl.pattern,
                message: InputPatternRuleBrandingUrl.message,
              },
            ]}
          >
            <Input
              className='af-form-input af-update_branding-form-input af-update_branding-form-input_url'
              disabled={recordData.id === 1}
              placeholder='customer1.yourdomain.com'
            />
          </FormLabel>
          <FormLabel
            name='themeId'
            label='Theme'
            rules={[
              {
                required: true,
                message: 'Please Enter this Field',
              },
            ]}
            className='formItemEvenLine af-form-item af-update_branding-form-item af-update_branding-form-item-theme_id'
          >
            <Select
              placeholder='Select Theme'
              className='af-form-select af-update_branding-form-select af-update_branding-form-select_theme_id'
            >
              {themeData.map((theme) => (
                <Select.Option
                  className='af-form-select-option af-update_branding-form-select-option'
                  key={theme.id}
                  value={theme.id}
                >
                  {theme.themeName}
                </Select.Option>
              ))}
            </Select>
          </FormLabel>
          {recordData.id !== 1 && (
            <FormLabel
              name='allowedDomains'
              label='Allowed Domains'
              className='formItemEvenLine af-form-item af-update_branding-form-item af-update_branding-form-item-allowed_domains'
              rules={[
                {
                  required: true,
                  message: 'Please Enter this Field',
                },
              ]}
            >
              <AllowedDomainWrap className='af-form-update_branding-allowed_domain-wrap'>
                <Checkbox
                  className='af-form-checkbox af-form-checkbox-update_branding-allowed_domain'
                  onChange={onCheckAllChange}
                  checked={checkAll}
                  indeterminate={checkedList.length > 0 && checkedList.length < options.length}
                >
                  Select All
                </Checkbox>
                <AllowedDomainListWrap className='af-form-update_branding-allowed_domain-wrap-list'>
                  <CheckboxGroup
                    className='af-form-checkbox af-form-checkbox-update_branding-allowed_domain'
                    options={options}
                    value={checkedList}
                    onChange={onChange}
                  />
                </AllowedDomainListWrap>
              </AllowedDomainWrap>
            </FormLabel>
          )}
          <FormLabel
            name='showDomains'
            label='Show Domain Dropdown'
            valuePropName='checked'
            className='formItemEvenLine af-form-item af-update_branding-form-item af-update_branding-form-item-show_domains'
          >
            <AntToggleButton
              className='af-form-switch af-form-switch-update_branding-show_domain'
              disabled={isToggleChecked || recordData.id === 1}
            />
          </FormLabel>
          <MiniInputWrap>
            <FormLabel
              name='forgotPassword'
              label='Forgot Password'
              valuePropName='checked'
              className='af-form-item af-update_branding-form-item af-update_branding-form-item-forgotPassword'
            >
              <AntToggleButton className='af-form-switch af-form-switch-update_branding-forgotPassword' />
            </FormLabel>
            <FormLabel
              name='rememberMe'
              label='Remember Me'
              valuePropName='checked'
              className='af-form-item af-update_branding-form-item af-update_branding-form-item-rememberMe'
            >
              <AntToggleButton className='af-form-switch af-form-switch-update_branding-rememberMe' />
            </FormLabel>
          </MiniInputWrap>

          <FormLabel
            style={{ textAlign: 'end' }}
            className='af-form-button-submit-wrapper af-update_branding-form-button-submit-wrapper'
          >
            <StyledButton
              type='primary'
              htmlType='submit'
              className='af-form-button af-update_branding-form-button af-update_branding-form-button_submit'
            >
              Update
            </StyledButton>
          </FormLabel>
        </Form>
      </FormWrap>
    </ModalFormContainer>
  );
}
